import { Spinner } from "@/components/ui/spinner"

export function ContractAnalysisLoadingView() {
  return (
    <div className="grid place-items-center h-svh">
      <div className="animate-pulse flex flex-row items-center gap-2 rounded-full bg-muted/50 px-4 py-2 pr-5">
        <Spinner />
        <h1 className="text-white text-sm">Loading contract</h1>
      </div>
    </div>
  )
}